module.exports = __webpack_public_path__ + "img/J13308.80b853ee.png";